/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		}, wait);
		if (immediate && !timeout) func.apply(context, args);
	};
}

 document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('.tab-header')).forEach(($tabHeader) => {
    const $tabItem = $tabHeader.querySelectorAll('h3')
    const $tabContentItem = document.querySelectorAll('.product-item')

    Array.from($tabItem).forEach(($item) => {
      $item.addEventListener('click', () => {
        const currentIndex = $item.dataset.tabIndex

        Array.from($tabContentItem).forEach(($content, index) => {
          const productIndex = $content.dataset.contentIndex
          $content.classList.remove('product-item--active')
          $tabItem[index] && $tabItem[index].classList.remove('tab--active')
          if (productIndex === currentIndex) {
            $content.classList.add('product-item--active')
          }
        })

        $item.classList.add('tab--active')
      })
    })
  })

  const $carousels = document.querySelectorAll('.Carousel')

  function delay (timeout) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, timeout)
    })
  }

 let flkty = {}
  async function initCarousel() {
    Array.from($carousels).forEach(($carousel, index) => {
      let config = $carousel.dataset.flickityConfig
      if (config) {
        config = JSON.parse(config)

        const sectionId = $carousel.closest('section').id
        
        
        // for mobile only
        if ($carousel.classList.contains('Carousel--mobile-only')) {
          if (window.innerWidth < 992) {
            flkty[sectionId] = new Flickity($carousel, config);
          } else {
            flkty[sectionId] && flkty[sectionId].destroy()
          }
        } else {
          flkty[sectionId] = new Flickity($carousel, config);
        }
      }
    })
  }

  function reloadCarousel() {
    const $carousels = document.querySelectorAll('.Carousel')
    Array.from($carousels).forEach(($carousel, index) => {
      const flkty = Flickity.data($carousel);
      if (flkty) {
        flkty.destroy();
      }
        new Flickity($carousel, JSON.parse($carousel.getAttribute('data-flickity-config')));
    });
  }

  function menuDrawerLanguage() {
    // const $menuDrawerSelectLanguage = document.getElementById('drawer-language-control')
    // const $popoverMenu = document.getElementById('header-locale-popover-drawer')
    // const $closeDrawer = document.getElementById('close-drawer-language')
    // $menuDrawerSelectLanguage.addEventListener('click', () => {
    //   const ariaHidden = $popoverMenu.getAttribute('aria-hidden')
    //   if (JSON.parse(ariaHidden) === true) {
    //     $popoverMenu.setAttribute('aria-hidden', false)
    //   } else {
    //     $popoverMenu.setAttribute('aria-hidden', true)
    //   }
    // })

    // $closeDrawer.addEventListener('click', () => {
    //   $popoverMenu.setAttribute('aria-hidden', true)
    // })
    
    const $menuHeaderSelectLanguages = document.querySelectorAll('.header-language-control-class');

    for (let i = 0; i < $menuHeaderSelectLanguages.length; i++) {
      const element = $menuHeaderSelectLanguages[i];
      
      const $popoverMenu = element.nextElementSibling;
      if ($popoverMenu) {
        const $closeDrawer = $popoverMenu.querySelector('.Popover__Close');
        
        element.addEventListener('click', () => {
          const ariaHidden = $popoverMenu.getAttribute('aria-hidden');
          if (JSON.parse(ariaHidden) === true) {
            $popoverMenu.setAttribute('aria-hidden', false);
    
            document.querySelector('#shopify-section-header').style.zIndex = 100;
            window.scrollTo(0, 0);
          } else {
            $popoverMenu.setAttribute('aria-hidden', true);
            // document.querySelector('#shopify-section-header').style.zIndex = '';
          }
        })
    
        $closeDrawer.addEventListener('click', () => {
          $popoverMenu.setAttribute('aria-hidden', true);
        })
      }
    }
  }

  function handleAnnouncementBar() {
    const $announcement  = document.getElementById('shopify-section-announcement')
    if ($announcement.innerHTML === '') {
      $announcement.classList.add('hidden-announcement')
    }
  }

  const $header = document.querySelector('.shopify-section--header')

  function handleHeaderScroll() {
    if (window.innerWidth >= 992) {
      if (window.scrollY > $header.offsetHeight) {
        document.body.classList.add('show-menu-header')
        
        if (window.scrollY > $header.offsetHeight * 2) {
          $header.classList.add('scroll-down')
        }
      } else {
        document.body.classList.remove('show-menu-header')
        $header.classList.remove('scroll-down')
  
      }
    }

    /* if (window.scrollY > 100) {
      document.body.classList.add('show-menu-header')
      if (window.scrollY > 400) {
        $header.classList.add('scroll-down')
      } else {
        $header.classList.remove('scroll-down')
      }
    } else {
      document.body.classList.remove('show-menu-header')
    } */
  }

  const sr = ScrollReveal();
  if (sr) {
    sr.reveal('.SectionHeader__Heading', { delay: 100, distance: '20px' });
    sr.reveal('.SectionHeader__SubHeading', { delay: 300, distance: '20px' });
    sr.reveal('.fade', { delay: 300, distance: '20px' });
    sr.reveal('.fade--delay', { delay: 500, distance: '20px' });
    sr.reveal('.fade--delay-1', { delay: 600, distance: '20px' });
  }

  const $seeMore  = document.querySelector('[data-action="see-more"]')
  const $seeLess  = document.querySelector('[data-action="see-less"]')

  function handleRevealMore ($el) {
    const toggleDisplay = () => {
      if (window.innerWidth < 768) {
        document.querySelector('.ingredients-filters').classList.toggle('is-open')
      }
    }
    
    if($el) {
      $el.addEventListener('click', toggleDisplay)
    }
  }
    const selectTag  = document.getElementById('taglist')
     if (selectTag) {
         selectTag.addEventListener('change', (e) => {
             const tag = e.target.value
             if (tag) {
                window.location.href = tag
             }
         })
     }
  
  handleRevealMore($seeMore)
  handleRevealMore($seeLess)

  initCarousel();
  handleAnnouncementBar();
  menuDrawerLanguage();
  handleHeaderScroll();
  //window.addEventListener('resize', debounce(reloadCarousel, 250));
  window.addEventListener('scroll', () => {
    handleHeaderScroll();
  });


  /*
  let cbb_loaded = false;
  //check if cbb is loaded / override add to cart buttons
    const checkLoaded = () => {
        if (document.body.classList.contains('cbb-collection-page')) {
            document.body.classList.add('loaded')
            cbb_loaded = true;
            let cbbButtons = document.querySelectorAll('.ProductItem');
            setTimeout(() => {
                cbbButtons.forEach((button) => {
                    let cbbButton = button.querySelector('.incubate-collections-add-to-cart-add-to-cart-button');

                    //create cheat button
                    let cheatButton = document.createElement('button');
                    cheatButton.classList.add('cbb-add-to-cart-button');
                    button.appendChild(cheatButton);

                    //action
                    cheatButton.addEventListener('mouseenter', (e) => {
                        cbbButton.classList.add('hover');
                    })
                    cheatButton.addEventListener('mouseleave', (e) => {
                        cbbButton.classList.remove('hover');
                    })
                    cheatButton.addEventListener('click', (e) => {
                        e.preventDefault()
                        cbbButton.click();
                        setTimeout(() => {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                            document.querySelector('[data-drawer-id="sidebar-cart"]').click()
                        }, 1500);
                    });

                })
            }, 1000);
        } else {
            setTimeout(checkLoaded, 3000);
        }
    }
 checkLoaded();
 */


})